<template>
<div :key="componenteChave">
  <v-flex>
    <div class="p-t-30 boxFamilias">
      <div v-for="item in enums.tipoDocumento" :key="item.chave+''+item.valor">
        <v-layout row wrap class v-if="mostrarBox(item.chave)" p-b-20>        
          <v-flex xs12>
            <v-card class="card--flex-toolbar">
              <v-toolbar
                light
                height="50px"
                v-bind:class="{'item-aprovado':(tipoDocumento[item.chave]['regularidadeFiscTrabSituacao']==2),'item-reprovado':(tipoDocumento[item.chave]['regularidadeFiscTrabSituacao']==1)}"
              >
                <v-toolbar-title>
                  <strong v-if="obrigatoriedadeDocumento(item.chave)">{{item.descricao + testeAstericoEstrangeiro(item.chave)}}</strong> 
                  <strong v-else>{{item.descricao}} </strong>
                  <span v-html="ifNovoDocumento('regularidadeFiscTrab',tipoDocumento[item.chave]['tipDocumento'],'tipDocumento')"></span>
                </v-toolbar-title>


                <!-- Mensagens personalizadas no botão de info -->
                   <v-menu v-if="item.chave === 'ContribuinteMunicipalServicos'">
                        <template slot="activator">
                          <v-icon color="primary" style="margin-top:-6px" light>info</v-icon>
                        </template>
					                <v-card class="boxInfoDoc">
                            <v-card-title>
                              <strong> Alvará de Funcionamento Municipal ou Ficha de Inscrição Municipal</strong>
                            </v-card-title>                          
                        </v-card>
                    </v-menu> 

                    <v-menu v-if="item.chave === 'EstadualBA'">
                        <template slot="activator">
                          <v-icon color="primary" style="margin-top:-6px" light>info</v-icon>
                        </template>
					                <v-card class="boxInfoDoc">
                          <v-card-title>
                            <strong>  Regularidade com a Fazenda Estadual da Bahia. Emitida no Portal 
                            <a href="https://www.sefaz.ba.gov.br/" target="_blank">https://www.sefaz.ba.gov.br/</a>.</strong>
                          </v-card-title>                          
                        </v-card>
                    </v-menu>                   
                  <!-- / Mensagens personalizadas no botão de info --> 

                <v-spacer></v-spacer>

                <v-tooltip top v-show="tipoDocumento[item.chave]['idRegularidadeFiscTrab']">
                  <v-icon
                    @click="aprovar(tipoDocumento[item.chave],2)"
                    class="mx-1"
                    slot="activator"
                    color="green"
                  >spellcheck</v-icon>
                  <span>Aprovar</span>
                </v-tooltip>

                <v-tooltip top v-show="tipoDocumento[item.chave]['idRegularidadeFiscTrab']">
                  <v-icon
                    @click="openModalRejetar(tipoDocumento[item.chave],1)"
                    class="mx-1"
                    slot="activator"
                    color="red accent-4"
                  >highlight_off</v-icon>
                  <span>Rejeitar</span>
                </v-tooltip>

                <v-btn icon @click="openBox(item)">
                  <v-icon color="primary">unfold_more</v-icon>
                </v-btn>
              </v-toolbar>

              <v-layout row wrap v-show="isShow[item.chave+''+item.valor]">
                <v-flex xs12 sm12  class="red--text">
                  <strong>   Para conseguir editar informações é preciso clicar no lapis à esquerda.</strong>
                </v-flex><br>
                <v-flex xs12 sm12>                   
                    <v-tooltip midle sm5>
                      <v-btn slot="activator" icon @click="editarRegularidade(item.chave)">                       
                        <v-icon color="grey">edit</v-icon>
                      </v-btn>
                      <span>Editar</span>
                    </v-tooltip>
                  </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="tipoDocumento[item.chave]['numDocumento']"
                    :label="labelNumDocumento(item.chave) + testeAstericoEstrangeiro(item.chave)"
                    :rules="obrigatoriedadeDocumento(item.chave) ? ((item.chave == 'CNPJ') ? validaIfObrigatorio().concat(validacao.cnpj) : validaIfObrigatorio()) : [] "
                    required
                    validate-on-blur
                    maxlength="30"
                    @change="alteracaoValorCampo(tipoDocumento[item.chave])"
                    :hint="ifRegularidadeFiscalAlterado(tipoDocumento[item.chave]['tipDocumento'],tipoDocumento[item.chave]['numDocumento'],'numDocumento')"
                    persistent-hint
                    v-mask="(item.chave == 'CNPJ')  ? maskCnpj : maskAnyChar"
                    :readonly="(item.chave === 'CNPJ')"
                  ></v-text-field>
                </v-flex>
                
                <v-flex v-if="exibeCampo(item.chave,'situacaoDoc')" xs12 sm6>
                  <v-select
                    v-model="tipoDocumento[item.chave]['situacaoDoc']"
                    :items="getSituacaoPorDoc(item.chave)"
                    :label="$t('label.situacao')+testeAstericoEstrangeiro(item.chave)"
                    item-text="descricao"
                    item-value="valor"
                    :return-object="false"
                    :key="tipoDocumento[item.chave]['situacaoDoc']+'_1'"
                    :rules="obrigatoriedadeDocumento(item.chave) ? validaIfObrigatorio(true,'situacaoDoc') : [] "
                    validate-on-blur
                    @change="alteracaoValorCampo(tipoDocumento[item.chave])"
                    :hint="ifRegularidadeFiscalAlterado(tipoDocumento[item.chave]['tipDocumento'],tipoDocumento[item.chave]['situacaoDoc'],'situacaoDoc')"
                    persistent-hint
                    :class="getClasseSituacaoPositiva(item.chave, tipoDocumento[item.chave]['situacaoDoc'])"
                  ></v-select>
                </v-flex>
               

                <v-flex xs6 sm4 md2 v-if="exibeCampo(item.chave,'dtEmissao')">                  
                  <datePicker
                    v-model="tipoDocumento[item.chave]['dtEmissao']"
                    :dataDefault="tipoDocumento[item.chave]['dtEmissao']"
                    v-mask="maskData"
                    :limitarData="true"
                    :rules="(obrigatoriedadeDocumento(item.chave) ? (validaIfObrigatorio((true)).concat([v=>validaDataInvalida(v,(true)) || 'Data Inválida'])) : [])" 
                    :label="$t('label.dataEmissao') +testeAstericoEstrangeiro(item.chave)"
                    required
                    validate-on-blur
                    @change="alteracaoValorCampo(tipoDocumento[item.chave])"
                    :hint="ifRegularidadeFiscalAlterado(tipoDocumento[item.chave]['tipDocumento'],tipoDocumento[item.chave]['dtEmissao'],'dtEmissao',true)"
                    persistent-hint
                  />
                </v-flex>

                <v-flex xs6 sm4 md2 v-if="exibeCampo(item.chave,'dtVencimento')">
                  <datePicker
                    v-model="tipoDocumento[item.chave]['dtVencimento']"
                    :dataDefault="tipoDocumento[item.chave]['dtVencimento']"
                    v-mask="maskData"                    
                    :label="$t('label.dataValidade') +testeAstericoEstrangeiro(item.chave)"                    
                    validate-on-blur
                    @change="alteracaoValorCampo(tipoDocumento[item.chave])"
                    :hint="ifRegularidadeFiscalAlterado(tipoDocumento[item.chave]['tipDocumento'],tipoDocumento[item.chave]['dtVencimento'],'dtVencimento',true)"
                    persistent-hint
                    :limitarDataVencida="permiteDataVencidaHabilitador()"
                  />
                </v-flex>

                <v-flex xs12 sm4 md3 v-if="exibeCampo(item.chave,'codControle')">
                  <v-text-field
                    v-model="tipoDocumento[item.chave]['codControle']"
                    maxlength="50"
                    :label="$t('label.codDeControle')"
                    @change="alteracaoValorCampo(tipoDocumento[item.chave])"
                    :hint="ifRegularidadeFiscalAlterado(tipoDocumento[item.chave]['tipDocumento'],tipoDocumento[item.chave]['codControle'],'codControle')"
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                
                <v-flex inputIcon xs12 sm12 md5 v-show="!isDocIntegradoSimpas(item.valor,tipoDocumento[item.chave]['tipDocumento'],tipoDocumento[item.chave]['arquivoUpload'],'arquivoUpload',tipoDocumento[item.chave]['novoUpload']) && !tipoDocumento[item.chave]['novoUpload']">
                  <v-text-field
                    :value="subStrUpload(tipoDocumento[item.chave]['arquivoUpload'],item.descricao)"
                    :label="$t('label.anexaDocumento')+testeAstericoEstrangeiro(item.chave)"                                        
                    append-icon="get_app"
                    readonly
                    :id="item.chave"
                    @click:append="baixarArquivo(tipoDocumento[item.chave]['arquivoUpload'])"                    
                    :hint="ifRegularidadeFiscalAlterado(tipoDocumento[item.chave]['tipDocumento'],tipoDocumento[item.chave]['arquivoUpload'],'arquivoUpload')"
                    persistent-hint
                  >
                    <template slot="append-outer">
                      <v-icon @click="iconDelete(item.chave)">clear</v-icon>
                    </template>
                  </v-text-field>
                </v-flex>
                

                <v-flex xs12 sm12 md5 v-show="!isDocIntegradoSimpas(item.valor,tipoDocumento[item.chave]['tipDocumento'],tipoDocumento[item.chave]['arquivoUpload'],'arquivoUpload' ) && tipoDocumento[item.chave]['novoUpload']">
                  <uploadFile
                    tamanhoMaximo="20MB"
                    :required="(obrigatoriedadeDocumento(item.chave)) && ((tipoDocumento[item.chave]['novoUpload'] && model.flagEstrangeiro==0))"
                    :label="$t('label.anexaDocumento') +testeAstericoEstrangeiro(item.chave)"
                    v-model="tipoDocumento[item.chave]['file']"
                    accept=".pdf, .PDF"
                  />
                </v-flex>

                <v-flex xs12 sm12 md4 v-if="item.chave === 'CNPJ' && model.tipFornecedor === 'J' && exibeCampo(item.chave,'dtAberturaEmpresa')">
                  <!-- Obrigar Data Abertura quando a lei entrar em vigor
                    <datePicker
                    v-model="tipoDocumento[item.chave]['dtAberturaEmpresa']"
                    :dataDefault="tipoDocumento[item.chave]['dtAberturaEmpresa']"
                    v-mask="maskData"
                    :limitarData="true"
                    :rules="(obrigatoriedadeDocumento(item.chave) ? (validaIfObrigatorio((true)).concat([v=>validaDataInvalida(v,(true)) || 'Data Inválida'])) : [])" 
                    
                    :label="$t('label.dataAberturaEmpresa') +testeAstericoEstrangeiro(item.chave)"
                    required
                    validate-on-blur                      

                    @change="alteracaoValorCampo(tipoDocumento[item.chave])"
                    :hint="ifRegularidadeFiscalAlterado(tipoDocumento[item.chave]['tipDocumento'],tipoDocumento[item.chave]['dtAberturaEmpresa'],'dtAberturaEmpresa',true)"
                    persistent-hint
                  /> -->
                  <datePicker
                    v-model="tipoDocumento[item.chave]['dtAberturaEmpresa']"
                    :dataDefault="tipoDocumento[item.chave]['dtAberturaEmpresa']"
                    v-mask="maskData"
                    :limitarData="true"
                    :rules="[]" 
                    
                    :label="$t('label.dataAberturaEmpresa') +testeAstericoEstrangeiro(item.chave)"
                    required
                    validate-on-blur                      

                    @change="alteracaoValorCampo(tipoDocumento[item.chave])"
                    :hint="ifRegularidadeFiscalAlterado(tipoDocumento[item.chave]['tipDocumento'],tipoDocumento[item.chave]['dtAberturaEmpresa'],'dtAberturaEmpresa',true)"
                    persistent-hint
                  />
                </v-flex>  
                
                <v-flex xs12>
                  <strong class="text-red" 
               
                    v-if="isDocIntegradoSimpas(item.valor,tipoDocumento[item.chave]['tipDocumento'],tipoDocumento[item.chave]['arquivoUpload'],'arquivoUpload' ) && (!ifRegularidadeFiscalAlterado(tipoDocumento[item.chave]['tipDocumento'],tipoDocumento[item.chave]['arquivoUpload'],'arquivoUpload') || tipoDocumento[item.chave]['arquivoUpload']  == 'integracao')">
                    Documento atualizado pela integração.
                  </strong>
                </v-flex>
              </v-layout>
            </v-card>
            
          </v-flex>
        </v-layout>
      </div>

      <v-dialog v-model="dialog" max-width="355" :persistent="persistent">
                  <v-card>
                    <v-card-title class="headline">Atenção!</v-card-title>
                    <v-form>
                      <v-layout row wrap>
                        <v-flex xs12><br />
                          Deseja excluir o documento?
                        </v-flex>
                      </v-layout><br /><br />
                      <v-layout wrap p-b-10>
                        <v-flex xs12 sm6>
                          <v-btn @click="cancelarDialog()">Não</v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>                          
                          <v-btn color="info" @click="limparArquivoTemp()" :loading="isLoading">Sim</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card>
                </v-dialog>

    </div>
  </v-flex>
  <dialogMotivoIndeferimento
    :config="modelDialogRejeitar"
    v-on:observacaoOk="rejeitar()"
    v-on:observacaoCancel="fnAcaoModalCancelar()"
  />
</div>
</template>
<script>
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import regularidadeFiscTrabService from "../../../services/regularidadeFiscTrabService";
import documentosService from "../../../services/documentosFornecService";
import analiseCampoAlterado from "./components/analiseCampoAlterado";
import Jquery from "jquery";
//import _ from "lodash";
export default {
name: "regularidade-fiscal",
mixins: [util,analiseCampoAlterado],
props: {//Propriedades que o objeto recebe como parametro
  model: Object, /*Solicitacao atual do Fornecedor*/
  enums: Object,
  tipoDocumento: Object,
  cadastroFornecedor: Function,
  OldModel: Object,
  rules: Array
},
data() {//Declaracao de variaveis
  return {   
    valorRef: '',
    dialog: false,
    componenteChave: 0,
    isShow: {},
    mostrarMaterial: false,
    mostrarServico: false,
    modelDialogRejeitar: {
      open: false,
      obs: null,
      titulo: "Motivo",
      codDocumento:0,
      motivoSelecionado:0
    },
    itemRejeitado: {},
    docsNovosOuAlterados: [],
    listaDocsIntegracaoSimpas: []
  };
},

watch: { //Propriedades assistidas
  "model.regularidadeFiscTrab": {
    handler(newValue) { /*Se houver um novo valor*/
      this.loadTela();
    }
  }
},
created() /*Metodo de start do componente*/{
  this.loadTela();
  this.$store.commit("setCalcLimpa", {
         setCalcLimpa: 2
    });
},
mounted(){
  //this.loadDocumentosNovosOuAlterados();
  // this.DocumentosAlterados();

},
methods: {//Declaracao de todos os metodos
  iconDelete(chave) {
    this.dialog = true;
    this.valorRef = chave;  
  },
  cancelarDialog() {
    this.dialog = false;
  },
  limparArquivoTemp() {
    this.novoUpload(this.valorRef);
    this.$emit("clear");
    this.dialog = false;
  },
  forceRerender() {
    this.componenteChave += 1;
  },
  loadTela() {
    //carregar a tela
    let _true = true;
    this.enums.tipoDocumento.filter(item => {
      var chave = item.chave;

      if (this.isShow[item.chave + "" + item.valor]) {
        _true = true;
      }
      else
      {
        _true = false;
      }
      this.$set(this.isShow, item.chave + "" + item.valor, _true);
      this.$set(this.tipoDocumento, chave, {
        novoUpload: true,
        tipDocumento: item.valor
      });

      var regularidadeFiscTrab = this.model.regularidadeFiscTrab.find(
        x => x.tipDocumento == item.valor
      );

      if (regularidadeFiscTrab) {
        if (regularidadeFiscTrab.arquivoUpload) {
          regularidadeFiscTrab.novoUpload = false;
        } else {
          regularidadeFiscTrab.novoUpload = true;
        }

        this.$set(this.tipoDocumento, chave, regularidadeFiscTrab);
      }
    });

    if(this.tipoDocumento['CNPJ'] != null && this.model.tipFornecedor === "J"){
      this.tipoDocumento['CNPJ']['numDocumento'] = this.model.numCgcFornecedor;
    }

    //this.loadDocumentosNovosOuAlterados();


    let idFornecSolicitacao=this.model.idFornecSolicitacao;
    documentosService.getSituacaoIntegracaoRegularidadeFiscal(idFornecSolicitacao)
    .then(response => {
      this.listaDocsIntegracaoSimpas = response.data;
    });
    

  },


  permiteDataVencidaHabilitador(){
  //caso o perfil seja habilitador e habilitadorMaster permite aceitar e rejeitar docs com data de validade vencida
    if(this.$verificaPerfilHabilitador()){
      return "";
    }
    else {
      return "true";
    }
  },

  testeAstericoEstrangeiro(chave) {
    //testar se o documento é obrigatorio
    //Não é obrigatório para estrangeiros, e nem para o documento Contribuinte Estadual
    if (this.model.tipoCertificado === 3 && chave === "ContribuinteMunicipalServicos" && this.model.tipFornecedor === 'F'  ) return "";
    else if (this.model.flagEstrangeiro === '0' && chave !== 'ContribuinteEstadualMaterial') return " *";
    else return "";
  },

  editarRegularidade(chave) {
      //limpar os dados para edição
    //  if (this.isAlteracao) {
        if(chave !== 'CNPJ'){
          this.tipoDocumento[chave]["numDocumento"] = null;
        }
        this.tipoDocumento[chave]["situacaoDoc"] = null;
        this.tipoDocumento[chave]["dtEmissao"] = null;
        this.tipoDocumento[chave]["dtAberturaEmpresa"] = null;
        this.tipoDocumento[chave]["dtVencimento"] = null;
        this.tipoDocumento[chave]["codControle"] = null;
        this.tipoDocumento[chave]["arquivoUpload"] = null;
        this.tipoDocumento[chave]["novoUpload"] = true;
        this.dtVencimentoKey++;
        this.dtEmissaoKey++;
        this.dtEmissao++;
        this.dtVencimento++;
        this.dtAberturaEmpresaKey++;
     // }
    },
  
  // #151962 - Remocao de não obrigatoriedade dos documentos RegularidadeComFGTS e Trabalhista para o fornecedor PJ e MEI, agora é obritorio para todos os fornecedores.
  // verificaCNPJMEI(chave){ 
  //   return ((chave === "RegularidadeComFGTS" || chave === "Trabalhista") && this.model.tipFornecedor === 'J' 
  //   && this.model.categoria === "MEI")
  // },
  
  validaIfObrigatorio(validar, tipoCampo) {
    //validar se é obrigatorio
    if(validar){

      if(tipoCampo === 'situacaoDoc'){
        return [];
      } else if (this.model.flagEstrangeiro === '0' ) {
        return this.validacao.campoObrigatorio;
      } else {
        return [];
      }
    }else {
        return [];
    }
  },

  validaDataInvalida(v, validar) {
    //verifica se a data é invalida
    if(validar){
    if (this.model.flagEstrangeiro === '0') {
      return v.length === 10;
    } else {
      if (v) {
        return v.length === 10;
      } else {
        return true;
      }
    }
    }else{
      return true;
    }
  },

  
  alteracaoValorCampo(dadosDocumento){
  //Remove validacao de documento caso um campo seja alterado 
    let arrayDocs = this.model.regularidadeFiscTrab;

    arrayDocs.forEach(function (item){
        if (item.$id === dadosDocumento.$id){
          item.regularidadeFiscTrabSituacao = null;
          item.dtRejeicao = null;
          item.idMotivoIndeferimentoArquivo = null;
        }  
    });
  },
  
  mostrarBox(chave) {
    //metodo para ver quais documentos devem aparecer em tela
    if (
      (this.model.codUf === "BA" && chave === "EstadualBA" && this.model.flagEstrangeiro !== '1') || // flagEstrangeiro é um tipo string
      (this.model.codUf === "DF" && (chave === "Municipal" || chave==="ContribuinteMunicipalServicos")  && this.model.flagEstrangeiro !== '1') ||
      (chave === "RegularidadeComFGTS" && this.model.tipFornecedor === 'F') ||
      this.naoExibeCartaoCNPJ(chave)
      )
    {
      return false;
    }

    return true;
  },
  

  naoExibeCartaoCNPJ(chave){
    return (chave === "CNPJ" && this.model.tipFornecedor === "F");
  },

  exibeCampo(chave,campo){
    switch(chave){
      case "CNPJ":
        //Exibe somente dtEmissao e numDocumento
        return (campo === "dtEmissao" || campo === "numDocumento" || campo === "dtAberturaEmpresa");
      case "ContribuinteMunicipalServicos":
      case "ContribuinteEstadualMaterial":
        //Não exibe situacaoDoc
        return (campo !== "situacaoDoc");
      case "RegularidadeComFGTS":
        return (campo !== "situacaoDoc")
      default:
        return true;
    }
  },

  labelNumDocumento(chave){
    if(chave === "CNPJ"){
      return this.$t('label.numeroInscricao');
    }else{
      return this.$t('label.numeroDocumento');
    }
  },

  novoUpload(chave) {
    //metodo para verificar se tem um novo documento para ser feito upload
    let teste = Object.assign({}, this.tipoDocumento[chave]);
    teste.novoUpload = true;
    this.$set(this.tipoDocumento, chave, teste);
  },
  baixarArquivo(arquivo) {
    //metodo para baixar o documento
    const numCgcFornecedor = this.$verificaPerfilHabilitador()
      ? this.model.numCgcFornecedor.replace(/[\W_]+/g,"")
      : null;
    fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
  },
  openBox(item) {
    //metodo para expandir os detalhes do documento
    const flag = this.isShow[item.chave + "" + item.valor];
    this.$set(this.isShow, item.chave + "" + item.valor, !flag);
  },

  obrigatoriedadeDocumento(chave){
    //metodo para a não obrigatoriedade do documento CADASTRO DE CONTRIBUINTE ESTADUAL
    
    if (chave === "ContribuinteEstadualMaterial"){
      return false;
    } else if ((chave === "ContribuinteMunicipalServicos") && (this.model.categoria === 'MEI' || this.model.tipoCertificado === 3)){
      return false;       
    } else if (chave === 'CNPJ' && this.model.flagEstrangeiro === '1'){
      return false;
    }  else if (this.model.tipoCertificado === 3 && chave === "ContribuinteMunicipalServicos" && this.model.tipFornecedor === 'F' ){
      return false;
    }    
    else {
      return true;
    }
  },

  openModalRejetar(itemLista) {
    //metodo para abrir o modal com os motivos de indeferimento para o documento
    Jquery(".v-card")
      .find(".v-toolbar__title  strong")
      .removeClass("error--text");

    Promise.all([this.cadastroFornecedor(true)]).then(valida => {
      if (valida[0]) {
        this.itemRejeitado = itemLista;
        this.modelDialogRejeitar.open = true;
        this.modelDialogRejeitar.motivoSelecionado = this.itemRejeitado.idMotivoIndeferimentoArquivo;
        this.modelDialogRejeitar.codDocumento = itemLista.tipDocumento;
      } else {
        setTimeout(() => {
          var erros = Jquery(".error--text")
            .closest(".v-card")
            .find(".v-toolbar__title  strong");

          erros.addClass("error--text");
        }, 1);
      }
    });
  },

  aprovar(itemLista) {

   this.$store.commit("setCalcLimpa", {
         setCalcLimpa: 2
    });
    //metodo para provar o documento
    Jquery(".v-card")
      .find(".v-toolbar__title  strong")
      .removeClass("error--text");

     Promise.all([this.cadastroFornecedor(true)]).then(valida => {
       console.log(valida);
       if (valida[0]) {
        let model = Object.assign({}, itemLista, {});
        model.regularidadeFiscTrabSituacao = 2;
        model.idMotivoIndeferimentoArquivo = null;
        regularidadeFiscTrabService.aprovarRejeitar(model).then(response => { /*resposta do servico*/
          itemLista.regularidadeFiscTrabSituacao = 2;
          this.model.regularidadeFiscTrab = response.data; /*dados de retorno*/

          this.loadTela();
          this.$toasted.success(
            this.$t("messages.cadastro.aprovadoComSucesso")
          );
          this.$parent.$el.reset();
          this.forceRerender();
        });
       } else {
        setTimeout(() => {
          var erros = Jquery(".error--text")
            .closest(".v-card")
            .find(".v-toolbar__title  strong");

          erros.addClass("error--text");
        }, 1);
      }
     });
  },

  rejeitar() {
    this.$store.commit("setCalcLimpa", {
                  setCalcLimpa: 2
                });
    //metodo para rejeitar o documento
    let model = Object.assign({}, this.itemRejeitado);
    model.regularidadeFiscTrabSituacao = 1;
    model.idMotivoIndeferimentoArquivo = this.modelDialogRejeitar.motivoSelecionado;
    regularidadeFiscTrabService.aprovarRejeitar(model).then(response => { /*resposta do servico*/
      this.itemRejeitado.regularidadeFiscTrabSituacao = 1;
      this.model.regularidadeFiscTrab = response.data; /*dados de retorno*/
      this.loadTela();
      this.fnAcaoModalCancelar();
      this.$toasted.success(this.$t("messages.cadastro.rejeitadoComSucesso"));
    });
        },

  fnAcaoModalCancelar() {
    //metodo para cancelar o rejeite do documento antes da peristencia
    this.modelDialogRejeitar.open = false;
  },

  getSituacaoPorDoc(chave){
    if(chave === 'Trabalhista'){
      return this.enums.situacaoDoc.filter(x => x.chave !== 'SemSituacao' && x.chave !== 'Positiva');
    }else if( chave === 'Municipal' || chave === 'FazendaFederalEINSS' || chave === 'Estadual'){
      return this.enums.situacaoDoc.filter(x => x.chave !== 'SemSituacao');
    }else{
      return this.enums.situacaoDoc;
    }
  
  },

  // possuiCamposDiferentesRegFiscal(doc1,doc2){
  //   return doc1["numDocumento"] !== doc2["numDocumento"]
  //         || doc1["dtEmissao"] !== doc2["dtEmissao"]
  //         || doc1["arquivoUpload"] !== doc2["arquivoUpload"]
  //         || doc1["codControle"] !== doc2["codControle"] 
  //         || doc1["dtVencimento"] !== doc2["dtVencimento"]
  //         || doc1["situacaoDoc"] !== doc2["situacaoDoc"];
  // },

  // getDocumentosAlterados(){
  //   let documentosNovos = this.analisaNovoModel['regularidadeFiscTrab'];
  //   let documentosAntigos = this.analisaOldModel['regularidadeFiscTrab'];
  //   let docsAlterados = [];

  //   if(documentosNovos == undefined || documentosAntigos == undefined) return docsAlterados;
    
  //   documentosNovos.forEach(element => {
  //     let docEncontrado = documentosAntigos.find(doc => doc.tipDocumento == element.tipDocumento);
  //     if(docEncontrado != undefined){
  //       let x = this.possuiCamposDiferentesRegFiscal(docEncontrado,element)
  //       if(this.possuiCamposDiferentesRegFiscal(docEncontrado,element)){
  //         docsAlterados.push(docEncontrado.tipDocumento);
  //       }
  //     }
  //   });

  //   return docsAlterados;
  // },

  getDocumentosExibidos(){
    return this.enums.tipoDocumento.filter(element => this.mostrarBox(element.chave));
  },

  /**
   * Retorna classe CSS para destacar situação "Positiva" em vermelho
   * nos documentos de regularidade fiscal específicos
   */
   getClasseSituacaoPositiva(chaveDocumento, situacaoDoc) {
    const documentosEspecificos = [
      'FazendaFederalEINSS',  // REGULARIDADE FAZENDA FEDERAL E A DIVIDA ATIVA E INSS
      'Estadual',             // REGULARIDADE COM A FAZENDA ESTADUAL
      'Municipal'             // REGULARIDADE COM A FAZENDA MUNICIPAL
    ];

    // Verificar se é um dos documentos específicos e se a situação é "Positiva"
    if (documentosEspecificos.includes(chaveDocumento) && this.isSituacaoPositiva(situacaoDoc)) {
      return 'status-positivo-vermelho';
    }
    
    return '';
  },

  /**
   * Verifica se a situação corresponde a "Positiva"
   */
  isSituacaoPositiva(situacaoDoc) {
    // Verificar pelo valor numérico ou texto, dependendo do enum
    // Assumindo que 'Positiva' tem valor específico no enum
    const situacaoPositiva = this.enums.situacaoDoc.find(s => s.chave === 'Positiva');
    return situacaoDoc === (situacaoPositiva && situacaoPositiva.valor) || situacaoDoc === 'Positiva';
  },

  /**
   * Retorna o texto da situação para exibição
   */
  getSituacaoTexto(situacaoDoc) {
    const situacao = this.enums.situacaoDoc.find(s => s.valor === situacaoDoc);
    return situacao ? situacao.descricao : '';
  },

  /**
   * Verifica se o documento está aprovado para exibir situação em modo leitura
   */
  isAprovado(documento) {
    return documento && documento.regularidadeFiscTrabSituacao === 2;
  },

  // getDocumentosNovos(){
  //   let docsAntigos = this.analisaOldModel['regularidadeFiscTrab']
  //   let docsExibidos = this.getDocumentosExibidos().map(x => x.valor);
    
  //   if(docsAntigos == undefined){
  //     return docsExibidos;
  //   }else{
  //     return docsExibidos.filter(exibido => !(docsAntigos.map(x => x.tipDocumento).includes(exibido)));
  //   }
  // },

  // loadDocumentosNovosOuAlterados(){
  //   this.docsNovosOuAlterados = this.getDocumentosNovos().concat(this.getDocumentosAlterados());
  // },

  isDocNovoOuAlterado2(codigo){
    return this.docsNovosOuAlterados.includes(codigo);
  },

  isDocIntegradoSimpas(codigo, tipoDoc,arquivo,nomeCampo,novoUpload){
    //Verifica se o documento foi possui a integração com o simpas válida

    let docIntegracao = this.listaDocsIntegracaoSimpas.find( doc => doc.codDocumento == codigo);
  
    let isAlterado = this.ifRegularidadeFiscalAlterado(tipoDoc,arquivo,nomeCampo);

    let novoDocumento = this.ifNovoDocumento('regularidadeFiscTrab',codigo,'tipDocumento');

    //só retorna verdadeiro se o documento tiver integração mas não tiver sido alterado pelo fornecedor

    if (docIntegracao && !isAlterado){
      
      if (novoDocumento.length>0){
        //Caso exista um novo upload de documento o campo upload deve aparecer na tela do habilitador
        return false;  
      }else if(arquivo == null && novoUpload) {
       //caso seja um novo upload e o não tenha anexo no documento analisado
        return false;  
      } else{
                        
        return true;
      }

    }else {
      return false;
    }
  },

}
};
</script>

<style scoped> /*CSS especifico do componente*/
.v-list__tile {
height: 60px;
}

.v-list__tile__sub-title {
font-size: 11px;
}

.v-list__tile--active {
font-family: gothambold;
}

.v-list__tile--active .v-list__tile__title {
color: #333;
}

.theme--light.v-subheader {
font-family: gothambold;
color: #10618b;
}

.tipoItem {
padding-top: 0;
}
.boxFamilias .v-toolbar__title {
font-size: 13px !important;
color: #10618b;
}

.boxInfoDoc {
  font-size: 11px !important;
  color: #10618b;
  text-align: center;
}

.boxInfoDoc .v-card__title {
  font-size: 13px !important;
}

/* Classe para destacar situação "Positiva" em vermelho */
.status-positivo-vermelho {
  color: #d32f2f !important;
  font-weight: bold !important;
}

/* Para campos de input/select */
.status-positivo-vermelho .v-input__control .v-input__slot {
  color: #d32f2f !important;
}

/* Para texto exibido */
.status-positivo-vermelho span,
.status-positivo-vermelho .v-select__selection {
  color: #d32f2f !important;
  font-weight: bold !important;
}

.situacao-documento {
  padding: 8px 0;
  font-size: 14px;
}
</style>